/**
 * Maps backend notes data to NotesListWidget view model.
 * Isolated so backend contract changes don't require rewriting UI.
 */
import { formatTimeAgo } from '../../../../../../utils/dateFormatters';

export const mapNoteItem = (raw) => {
  const title = raw?.title ?? raw?.content ?? 'Title of the Note';
  const description = raw?.description ?? (typeof raw?.content === 'string' ? raw.content : '');
  return {
    id: raw?.id ?? '',
    title,
    description: description || '',
    dueDate: raw?.dueDate ?? formatDueDate(raw?.date ?? raw?.dueDate ?? raw?.createdAt),
    author: raw?.author ?? raw?.userName ?? '',
    timeAgo: raw?.timeAgo ?? formatTimeAgo(raw?.date ?? raw?.timestamp ?? raw?.createdAt),
    metadata: {
      commentsCount: raw?.commentsCount ?? raw?.metadata?.commentsCount ?? 0,
      attachmentsCount: raw?.attachmentsCount ?? raw?.metadata?.attachmentsCount ?? 0,
      tasksCount: raw?.tasksCount ?? raw?.metadata?.tasksCount ?? 0,
    },
  };
};

export const mapNotesListData = (rawData) => {
  if (!rawData) return { title: '', items: [] };
  const items = Array.isArray(rawData.items) ? rawData.items : [];
  return {
    title: rawData.title ?? 'Notes',
    items: items.map(mapNoteItem),
  };
};

function formatDueDate(dateInput) {
  if (!dateInput) return '';
  const date = typeof dateInput === 'string' ? new Date(dateInput) : dateInput;
  if (Number.isNaN(date.getTime())) return '';
  const month = date.toLocaleString('en-US', { month: 'short' });
  const day = date.getDate();
  return `${month} ${day}`;
}
